export const GET_SEARCH_DROPDOWN_INIT = "GET_SEARCH_DROPDOWN_INIT";
export const GET_SEARCH_DROPDOWN_SUCCESS = "GET_SEARCH_DROPDOWN_SUCCESS";
export const GET_SEARCH_DROPDOWN_FAILED = "GET_SEARCH_DROPDOWN_FAILED";
export const RESET_SEARCH_DROPDOWN="RESET_SEARCH_DROPDOWN";
export const RESET_SEARCH_DROPDOWN_SUCCESS="RESET_SEARCH_DROPDOWN_SUCCESS";